export default __webpack_public_path__ + "static/media/star_1.e820b183.svg";